import React, { useEffect, useState } from "react";
import { Table, Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import axios from "axios";
import { API_URL_batch_proyectos } from "../../constants";
import NewBacthProyectoForm from "./NewBacthProyectoForm";
import { getAuthHeaders } from "../../utils/auth";

const BatchProyectoTable = () => {
    const [batchProyectos, setBatchProyectos] = useState([]);
    const [selectedBatch, setSelectedBatch] = useState(null); // Batch to edit
    const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchBatchProyectos = async () => {
            try {
                const headers = getAuthHeaders();
                const response = await axios.get(API_URL_batch_proyectos, { headers });
                console.log("API Response:", response.data);
                if (Array.isArray(response.data)) {
                    setBatchProyectos(response.data);
                } else {
                    setError(`Unexpected data format: ${JSON.stringify(response.data)}`);
                }
            } catch (err) {
                console.error("Error fetching batch proyectos:", err);
                setError("Failed to fetch batch proyectos. Please try again later.");
            }
        };

        fetchBatchProyectos();
    }, []);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const handleEditBatch = (batch) => {
        setSelectedBatch(batch);
        toggleModal();
    };

    const resetState = () => {
        setSelectedBatch(null);
        toggleModal();
        // Optionally, refresh the table
        const fetchBatchProyectos = async () => {
            try {
                const headers = getAuthHeaders();
                const response = await axios.get(API_URL_batch_proyectos, { headers });
                setBatchProyectos(response.data);
            } catch (err) {
                console.error("Error refreshing batch proyectos:", err);
            }
        };
        fetchBatchProyectos();
    };

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div>
            <h2>Bundle Proyectos</h2>
            <Table bordered responsive>
                <thead>
                    <tr>
                        <th>Bundle Code</th>
                        <th>Bundle Name</th>
                        <th>Created At</th>
                        <th>Proyectos</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {batchProyectos.length > 0 ? (
                        batchProyectos.map((batch, index) => (
                            <tr key={index}>
                                <td>{batch.batch_code}</td>
                                <td>{batch.batch_name || "Unnamed Batch"}</td>
                                <td>{new Date(batch.created_at).toLocaleString()}</td>
                                <td>
                                    <Table size="sm" bordered>
                                        <thead>
                                            <tr>
                                                <th>Proyecto Name</th>
                                                <th>Revenue Percentage</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Array.isArray(batch.proyectos) &&
                                                batch.proyectos.map((proyecto, i) => (
                                                    <tr key={i}>
                                                        <td>{proyecto.proyecto_name}</td>
                                                        <td>{proyecto.revenue_percentage}%</td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </Table>
                                </td>
                                <td>
                                    <Button
                                        color="primary"
                                        size="sm"
                                        onClick={() => handleEditBatch(batch)}
                                    >
                                        Edit
                                    </Button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="5">No Bundle Proyectos found.</td>
                        </tr>
                    )}
                </tbody>
            </Table>

            {/* Modal for NewBatchProyectoForm */}
            <Modal isOpen={isModalOpen} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>
                    {selectedBatch ? "Edit Batch" : "New Batch"}
                </ModalHeader>
                <ModalBody>
                    <NewBacthProyectoForm
                        toggle={toggleModal}
                        resetState={resetState}
                        batch={selectedBatch}
                    />
                </ModalBody>
            </Modal>
        </div>
    );
};

export default BatchProyectoTable;